export default __webpack_public_path__ + "static/portfolio-mas-1-ed90e1a90c729bc1d547c7ef523f7f48.jpg";